import { CustomRoute, ItemStatus, PointType, TransferIconNameMap } from '../interfaces/custom-route.interface';
import { DailyRouteResponse, DailyStats, GlobalStats } from "../interfaces/custom-route.response";

export const customRouteAdapter = (
  id: number,
  dailyRoutes: DailyRouteResponse[],
  token: string,
  language: string, 
  stats?: { dailyStats: DailyStats[]; globalStats: GlobalStats }
): CustomRoute => {
  return {
    id: id,
    token: token,
    language: language,
    dailyRoutes: (dailyRoutes || []).map(dailyRoute => ({
      id: dailyRoute.id,
      date: new Date(dailyRoute.date),
      weatherIconName: dailyRoute.weather ? dailyRoute.weather.iconName : null,
      startPoint: {
        lat: dailyRoute.startPoint.lat,
        lng: dailyRoute.startPoint.lng,
        address: dailyRoute.startPoint.address
      },
      endPoint: dailyRoute.endPoint ? {
        lat: dailyRoute.endPoint.lat,
        lng: dailyRoute.endPoint.lng,
        address: dailyRoute.endPoint.address
      } : undefined,
      points: (dailyRoute.points || []).map(point => ({
        id: point.id,
        type: point.type as PointType,
        categoryList: point.category || [],
        img: point.img,
        status: ItemStatus.PENDING,
        title: point.title,
        startDate: new Date(point.startDate),
        endDate: new Date(point.endDate),
        duration: point.duration,
        previousLocation: {
          lat: point.previousLocation.lat,
          lng: point.previousLocation.lng,
          address: point.previousLocation.address
        },
        currentLocation: {
          lat: point.currentLocation.lat,
          lng: point.currentLocation.lng,
          address: point.currentLocation.address
        },
        polylinesPath: (point.polylinesPath || []).map(location => ({
          lat: location.lat,
          lng: location.lng,
        })),
        totalTransferDistance: point.totalTransferDistance,
        totalTransferDuration: point.totalTransferDuration,
        transfers: (point.transfers || []).map(transfer => ({
          instruction: transfer.instruction,
          distance: transfer.distance,
          duration: transfer.duration,
          location: {
            lat: transfer.location.lat,
            lng: transfer.location.lng,
          },
          mode: transfer.mode,
          iconName: transfer.icon ?? TransferIconNameMap.walk
        })),
        transportList: (point.transportList || []).map(transport => ({
          id: transport.id,
          name: transport.name,
          stopDetails: transport.instruction,
          duration: Math.round(transport.duration) ?? 1, // duration in minutes, minimum 1 minute
          iconName: transport.iconName ?? TransferIconNameMap.walk
        })),
        nextPoint: point.nextPoint,
        relateds: point.relateds,
        relatedsItems: (point.relatedsItems || []).map(e => ({
          ...e,
          currentLocation: {lat: Number(e.latitude), lng: Number(e.longitude)}
        })),
        immersive: point.immersive
      }))
    })),
    stats: stats
  }
};